(function () {
  'use strict';

  /* ---- mobile menu ---- */
  var mb = document.querySelector('[data-menu]');
  if (mb) {
    mb.addEventListener('click', function () {
      var nav = document.getElementById('kp-nav');
      if (!nav) return;
      var open = nav.classList.toggle('open');
      mb.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---- header search: an icon until you ask for it ---- */
  document.querySelectorAll('.msearch').forEach(function (f) {
    var input = f.querySelector('input');
    var btn = f.querySelector('button');
    if (!input || !btn) return;
    btn.addEventListener('click', function (e) {
      var open = f.classList.contains('open') || f.matches(':focus-within');
      if (!open || !input.value.trim()) {
        e.preventDefault();
        f.classList.add('open');
        input.focus();
      }
    });
    input.addEventListener('blur', function () {
      if (!input.value.trim()) f.classList.remove('open');
    });
  });

  /* ---- catalog filter chips ---- */
  var chips = document.querySelectorAll('.chip[data-filter]');
  var grid = document.querySelector('[data-grid]');
  var shown = document.querySelector('[data-shown]');
  if (chips.length && grid) {
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var f = chip.getAttribute('data-filter');
        chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c === chip)); });
        var n = 0;
        grid.querySelectorAll('.card').forEach(function (card) {
          var match = f === '*' || card.getAttribute('data-type') === f;
          card.hidden = !match;
          if (match) n++;
        });
        if (shown) shown.textContent = n;
      });
    });
  }

  /* ---- mount colour: sampled from the photo's own corners ---- */
  var swatchCache = {};

  function sampleSwatch(url, cb) {
    if (!url) { cb(''); return; }
    if (Object.prototype.hasOwnProperty.call(swatchCache, url)) { cb(swatchCache[url]); return; }
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onerror = function () { swatchCache[url] = ''; cb(''); };
    probe.onload = function () {
      var rgb = '';
      try {
        var n = 30, c = document.createElement('canvas');
        c.width = n; c.height = n;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(probe, 0, 0, n, n);
        var d = ctx.getImageData(0, 0, n, n).data;
        function patch(x0, y0) {
          var out = [];
          for (var y = y0; y < y0 + 5; y++) {
            for (var x = x0; x < x0 + 5; x++) {
              var i = (y * n + x) * 4;
              if (d[i + 3] < 200) continue;
              out.push([d[i], d[i + 1], d[i + 2]]);
            }
          }
          if (!out.length) return null;
          out.sort(function (p, q) { return (p[0] + p[1] + p[2]) - (q[0] + q[1] + q[2]); });
          return out[Math.floor(out.length / 2)];
        }
        var e = 1, f = n - 6;
        var corners = [patch(e, e), patch(f, e), patch(e, f), patch(f, f)].filter(Boolean);
        if (corners.length >= 3) {
          corners.sort(function (p, q) { return (p[0] + p[1] + p[2]) - (q[0] + q[1] + q[2]); });
          var m = corners[Math.floor(corners.length / 2)];
          rgb = 'rgb(' + m[0] + ',' + m[1] + ',' + m[2] + ')';
        }
      } catch (err) { rgb = ''; }
      swatchCache[url] = rgb;
      cb(rgb);
    };
    probe.src = url;
  }

  /* paint synchronously from whatever we already know */
  function applyMount(box, mounted, colour) {
    if (!box) return;
    box.classList.toggle('is-mounted', !!mounted);
    box.style.backgroundColor = mounted ? (colour || '') : '';
  }

  /* ---- product gallery ---- */
  var main = document.querySelector('[data-main]');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-thumb]'));
  var galBox = document.querySelector('.gal-main');

  if (main && galBox) {
    var startMounted = main.getAttribute('data-mount') === 'true';
    var startHex = main.getAttribute('data-mount-hex');
    if (startMounted && startHex) {
      applyMount(galBox, true, startHex);
    } else if (startMounted) {
      sampleSwatch(main.getAttribute('data-swatch'), function (rgb) { applyMount(galBox, true, rgb); });
    } else {
      applyMount(galBox, false, '');
    }
  }

  if (main && galBox && thumbs.length) {
    var LO = 0.60, HI = 1.30;
    var at = 0;
    thumbs[0].setAttribute('aria-current', 'true');

    /* warm both caches up front so a click never waits on the network */
    idle(function () {
      thumbs.forEach(function (t) {
        var pre = new Image();
        pre.src = t.getAttribute('data-thumb');
        sampleSwatch(t.getAttribute('data-swatch'), function () {});
      });
    });

    function show(k) {
      if (k === at) return;
      var n = thumbs.length;
      at = ((k % n) + n) % n;
      var t = thumbs[at];
      var url = t.getAttribute('data-thumb');
      var sw = t.getAttribute('data-swatch');
      var ar = parseFloat(t.getAttribute('data-ar')) || 0.75;
      var mount = t.getAttribute('data-png') !== '1' && (ar < LO || ar > HI);

      thumbs.forEach(function (x, j) { x.setAttribute('aria-current', String(j === at)); });

      var pic = new Image();
      var picReady = false, colReady = false, colour = '';
      function commit() {
        if (!picReady || !colReady) return;
        /* image bytes and mount colour are both in hand: swap them together */
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.removeAttribute('data-mount-hex');
        main.setAttribute('data-mount', String(mount));
        main.setAttribute('data-swatch', sw);
        applyMount(galBox, mount, colour);
        main.classList.toggle('mounted', mount);
        main.src = url;
      }
      pic.onload = pic.onerror = function () { picReady = true; commit(); };
      pic.src = url;
      if (!mount) { colReady = true; commit(); }
      else sampleSwatch(sw, function (rgb) { colour = rgb; colReady = true; commit(); });
    }

    thumbs.forEach(function (t, j) {
      t.addEventListener('click', function () { show(j); });
    });

    document.querySelectorAll('[data-gal]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        show(at + parseInt(b.getAttribute('data-gal'), 10));
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.target && /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return;
      if (e.key === 'ArrowLeft') show(at - 1);
      else if (e.key === 'ArrowRight') show(at + 1);
    });

    /* swipe the main image too */
    swipe(galBox, function (dir) { show(at + dir); });
  }

  /* ---- card carousels: swipe through a pattern's shots from the grid ---- */
  document.querySelectorAll('[data-carousel]').forEach(function (car) {
    var slides = Array.prototype.slice.call(car.querySelectorAll('.slide'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(car.querySelectorAll('.cardots span'));
    var i = 0;
    function go(next) {
      i = ((next % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    }
    var prev = car.querySelector('.carnav.prev');
    var next = car.querySelector('.carnav.next');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(i - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(i + 1); });
    swipe(car, function (dir) { go(i + dir); });
  });

  /* pointer swipe / drag. dir = +1 to advance, -1 to go back.
     suppresses the click that would otherwise follow a drag on a link. */
  function swipe(el, onSwipe) {
    if (!el) return;
    /* links and images start a native drag that swallows the pointer stream */
    el.querySelectorAll('a,img').forEach(function (n) { n.draggable = false; });
    var x0 = 0, y0 = 0, x1 = 0, y1 = 0, id = null, moved = false;
    el.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      id = e.pointerId; x0 = e.clientX; y0 = e.clientY; x1 = e.clientX; y1 = e.clientY; moved = false;
    });
    el.addEventListener('pointermove', function (e) {
      if (id === null || e.pointerId !== id) return;
      x1 = e.clientX; y1 = e.clientY;
      if (Math.abs(x1 - x0) > 8 && Math.abs(x1 - x0) > Math.abs(y1 - y0)) moved = true;
    });
    function settle(ex, ey, min) {
      id = null;
      var dx = ex - x0, dy = ey - y0;
      if (Math.abs(dx) < min || Math.abs(dx) < Math.abs(dy)) { moved = false; return; }
      onSwipe(dx < 0 ? 1 : -1);
    }
    el.addEventListener('pointerup', function (e) {
      if (id === null || e.pointerId !== id) return;
      settle(e.clientX, e.clientY, 40);
    });
    /* a native drag or a browser gesture can cancel the stream mid-swipe;
       fall back to the last position we saw so the card still turns */
    el.addEventListener('pointercancel', function (e) {
      if (id === null || e.pointerId !== id) return;
      settle(x1, y1, 24);
    });
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    /* if the browser insists on running a native drag anyway, ride it:
       track the drag's own coordinates and settle on dragend. */
    var dx0 = 0, dxLast = 0, dragging = false;
    el.addEventListener('dragstart', function (e) {
      e.preventDefault();
      dragging = true; dx0 = e.clientX || x0; dxLast = dx0; moved = false;
    });
    el.addEventListener('drag', function (e) {
      if (!dragging) return;
      if (e.clientX) dxLast = e.clientX;
      if (Math.abs(dxLast - dx0) > 8) moved = true;
    });
    el.addEventListener('dragend', function (e) {
      if (!dragging) return;
      dragging = false; id = null;
      var d = (e.clientX || dxLast) - dx0;
      if (Math.abs(d) >= 40) onSwipe(d < 0 ? 1 : -1);
      else moved = false;
    });

    /* trackpad: a two-finger horizontal swipe arrives as wheel deltaX */
    var acc = 0, cool = 0, decay = null;
    el.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;   /* vertical: let the page scroll */
      e.preventDefault();
      var now = Date.now();
      if (now < cool) return;
      acc += e.deltaX;
      clearTimeout(decay);
      decay = setTimeout(function () { acc = 0; }, 220);
      if (Math.abs(acc) >= 60) {
        onSwipe(acc > 0 ? 1 : -1);
        acc = 0; cool = now + 420;
      }
    }, { passive: false });
  }

  function idle(fn) {
    if (window.requestIdleCallback) { window.requestIdleCallback(fn, { timeout: 2000 }); }
    else { setTimeout(fn, 400); }
  }

  /* ---- variant swatches -> hidden select ---- */
  var sel = document.querySelector('[data-variants]');
  if (sel) {
    var groups = document.querySelectorAll('.swatches[data-opt]');
    var sync = function () {
      var chosen = [];
      groups.forEach(function (g) {
        var on = g.querySelector('.sw[aria-pressed="true"]');
        chosen.push(on ? on.getAttribute('data-value') : '');
      });
      var want = chosen.join(' / ');
      Array.prototype.forEach.call(sel.options, function (o) {
        if (o.getAttribute('data-title') === want) {
          sel.value = o.value;
          var btn = document.querySelector('#kp-buy button[type="submit"]');
          if (btn) {
            btn.disabled = o.disabled;
            if (o.disabled) btn.textContent = 'Unavailable';
          }
        }
      });
    };
    groups.forEach(function (g) {
      g.querySelectorAll('.sw').forEach(function (b) {
        b.addEventListener('click', function () {
          g.querySelectorAll('.sw').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          sync();
        });
      });
    });
  }

  /* ---- bundle progress line, kept in step with the cart ---- */
  function renderBundle(count) {
    document.querySelectorAll('[data-bundle]').forEach(function (el) {
      var need = parseInt(el.getAttribute('data-qty'), 10);
      var pct = parseInt(el.getAttribute('data-pct'), 10);
      if (!need || !pct) return;
      var left = need - count;
      el.classList.toggle('bundle-on', left <= 0);
      if (left <= 0) el.textContent = pct + '% bundle discount applied at checkout.';
      else if (left === 1) el.textContent = 'One more pattern and ' + pct + '% comes off.';
      else el.textContent = 'Add ' + left + ' more patterns and take ' + pct + '% off.';
    });
  }

  function money(cents, iso) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: iso || 'USD'
      }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* ---- add to cart without leaving the page ---- */
  var buyForm = document.getElementById('kp-buy');
  var buyRow = buyForm && buyForm.querySelector('[data-buy]');
  if (buyForm && buyRow && window.fetch) {
    var addUrl = buyRow.getAttribute('data-add-url');
    var cartUrl = buyRow.getAttribute('data-cart-url');
    var added = document.querySelector('[data-added]');
    var addedText = document.querySelector('[data-added-text]');
    var wantCheckout = false;

    buyRow.querySelectorAll('button[type="submit"]').forEach(function (b) {
      b.addEventListener('click', function () {
        wantCheckout = b.hasAttribute('data-buynow');
      });
    });

    buyForm.addEventListener('submit', function (e) {
      var sel = buyForm.querySelector('[data-variants]');
      var id = sel && sel.value;
      if (!id) return;                                  /* let the browser post it */
      e.preventDefault();

      var pressed = wantCheckout
        ? buyRow.querySelector('[data-buynow]')
        : buyRow.querySelector('[data-add]');
      var label = pressed ? pressed.textContent : '';
      if (pressed) { pressed.disabled = true; pressed.textContent = 'Adding…'; }

      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          if (wantCheckout) { window.location.href = cartUrl.replace(/\/cart$/, '') + '/checkout'; return null; }
          return fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (!cart) return;
          if (pressed) { pressed.disabled = false; pressed.textContent = label; }
          document.querySelectorAll('[data-cart-count]').forEach(function (n) {
            n.textContent = cart.item_count;
          });
          if (added) {
            if (addedText) {
              addedText.textContent = cart.item_count === 1
                ? 'Added. 1 item in your cart.'
                : 'Added. ' + cart.item_count + ' items in your cart.';
            }
            added.hidden = false;
          }
          renderBundle((cart.items||[]).reduce(function(a,b){return a+(b.requires_shipping?0:b.quantity)},0));
          document.dispatchEvent(new CustomEvent('kp:cart', { detail: cart }));
        })
        .catch(function () {
          /* network or endpoint trouble: fall back to a normal form post */
          if (pressed) { pressed.disabled = false; pressed.textContent = label; }
          buyForm.submit();
        });
    });
  }

  /* ---- cart: quantities apply as you press, no Update button ---- */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm && window.fetch) {
    var changeUrl = cartForm.getAttribute('data-change-url');
    var iso = cartForm.getAttribute('data-currency');
    var busy = false;

    function commitLine(row, qty) {
      if (busy) return;
      busy = true;
      cartForm.classList.add('is-busy');
      fetch(changeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(row.getAttribute('data-line'), 10), quantity: qty })
      })
        .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
        .then(function (cart) {
          if (qty === 0 || cart.item_count === 0) { window.location.reload(); return; }
          var line = cart.items[parseInt(row.getAttribute('data-line'), 10) - 1];
          var total = row.querySelector('[data-line-total]');
          if (line && total) total.textContent = money(line.original_line_price, iso);
          var sub = document.querySelector('[data-subtotal]');
          if (sub) sub.textContent = money(cart.total_price, iso);
          document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
          renderBundle((cart.items||[]).reduce(function(a,b){return a+(b.requires_shipping?0:b.quantity)},0));
          busy = false;
          cartForm.classList.remove('is-busy');
        })
        .catch(function () { window.location.reload(); });
    }

    cartForm.querySelectorAll('.qty [data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentNode.querySelector('input');
        var row = b.closest('tr');
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-step'), 10));
        input.value = next;
        commitLine(row, next);
      });
    });

    cartForm.querySelectorAll('.qty input').forEach(function (input) {
      input.addEventListener('change', function () {
        var next = Math.max(0, parseInt(input.value, 10) || 0);
        input.value = next;
        commitLine(input.closest('tr'), next);
      });
    });

    cartForm.querySelectorAll('[data-remove]').forEach(function (b) {
      b.addEventListener('click', function () { commitLine(b.closest('tr'), 0); });
    });
  } else {
    document.querySelectorAll('.qty [data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentNode.querySelector('input');
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-step'), 10));
      });
    });
  }
})();

/* ---------- sticky buy bar on the phone product page ----------
   Appears once the real Add to cart button has scrolled out of sight, and
   forwards its click to that button so there is only one add-to-cart path. */
(function () {
  var bar = document.querySelector('[data-stickybuy]');
  if (!bar) return;
  var realAdd = document.querySelector('[data-add]');
  if (!realAdd) return;

  var stickyBtn = bar.querySelector('[data-sticky-add]');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () { realAdd.click(); });
  }

  var buyrow = realAdd.closest('.buyrow') || realAdd;

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      bar.hidden = entries[0].isIntersecting;
    }, { rootMargin: '0px 0px -40px 0px' }).observe(buyrow);
  } else {
    var check = function () {
      var r = buyrow.getBoundingClientRect();
      bar.hidden = r.bottom > 0 && r.top < window.innerHeight;
    };
    window.addEventListener('scroll', check, { passive: true });
    check();
  }
})();
